import React, { useState, useEffect, useCallback } from 'react';
import api, { asArray, errorMessage } from '../api';
import { formatSpan } from '../lib/datetime';
import { ClockIcon, MapIcon } from './icons';

/**
 * Träffarna som hör till en profil: egna, anmälda och sparade.
 *
 * Kompakta rader i stället för fulla träffkort — här handlar det om att få
 * överblick över sina egna, inte om att bläddra och upptäcka.
 */
const TABS = [
  { id: 'created', label: 'Mina träffar' },
  { id: 'attending', label: 'Jag kommer' },
  { id: 'saved', label: 'Sparade' },
];

export default function ProfileMeets() {
  const [relation, setRelation] = useState('created');
  const [meets, setMeets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      // Bade kommande och passerade, sa att egna traffar inte forsvinner.
      const [kommande, tidigare] = await Promise.all([
        api.get('/meets', { params: { relation } }),
        api.get('/meets', { params: { relation, when: 'past' } }),
      ]);
      setMeets([...asArray(kommande.data), ...asArray(tidigare.data)]);
    } catch (err) {
      setError(errorMessage(err, 'Träffarna kunde inte hämtas.'));
    } finally {
      setLoading(false);
    }
  }, [relation]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="profile-meets">
      <div className="tabs">
        {TABS.map(item => (
          <button
            key={item.id}
            className={relation === item.id ? 'is-active' : ''}
            onClick={() => setRelation(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>

      {error && <p className="notice notice--error">{error}</p>}
      {loading && <p className="empty">Hämtar…</p>}

      {!loading && meets.length === 0 && (
        <p className="empty">
          {relation === 'created' && 'Du har inte skapat någon träff än.'}
          {relation === 'attending' && 'Du har inte anmält dig till någon träff.'}
          {relation === 'saved' && 'Inga sparade träffar.'}
        </p>
      )}

      {meets.map(meet => (
        <div key={meet.id} className="meet-row">
          <span className="meet-row__title">{meet.title}</span>
          <span className="meet-row__line">
            <ClockIcon size={13} />
            {formatSpan(meet.event_date, meet.end_date)}
          </span>
          {meet.address && (
            <span className="meet-row__line">
              <MapIcon size={13} />
              {meet.address}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
